import { Eyebrows, Eyes, Hair, Mouth, BackHair, Eyeline } from "@/types";

const INITIAL_PART_NAME = "hair";
const INITIAL_FILL_COLOR = "#bc8f8f";

const INITIAL_HAIR_STYLE: Hair = {
	fill: INITIAL_FILL_COLOR,
	line: "#8b4513",
};

const INITIAL_BACK_HAIR_STYLE: BackHair = {
	fill: INITIAL_FILL_COLOR,
	line: "#8b4513",
};

const INITIAL_EYEBROWS_STYLE: Eyebrows = {
	fill: INITIAL_FILL_COLOR,
	scale: 1,
	leftPositionX: 0,
	rightPositionX: 0,
	positionY: 0,
	leftRotate: 0,
	rightRotate: 0,
};

const INITIAL_EYELINE_STYLE: Eyeline = {
	fill: INITIAL_FILL_COLOR,
	scale: 1.2,
	leftPositionX: 0,
	rightPositionX: 0,
	positionY: 0,
	leftRotate: 0,
	rightRotate: 0,
	showProcess: 3,
	skinColor:"#fef9f6"
};

const INITIAL_PREVIEW_EYELINE_STYLE: Eyeline = {
	fill: INITIAL_FILL_COLOR,
	scale: 1,
	leftPositionX: 0,
	rightPositionX: 0,
	positionY: 0,
	leftRotate: 0,
	rightRotate: 0,
};

const INITIAL_EYES_STYLE: Eyes = {
	fill: "#191919",
	fill_1: "#3f3f3f",
	fill_2: "#7e7e7e",
	fill_3: "#bebebe",
	scale: 1,
	leftPositionX: 0,
	rightPositionX: 0,
	positionY: 0,
};

const INITIAL_MOUTH_STYLE: Mouth = {
	fill: "#f08080",
	scale: 1,
	positionY: 0,
};

export {
	INITIAL_HAIR_STYLE,
	INITIAL_BACK_HAIR_STYLE,
	INITIAL_EYEBROWS_STYLE,
	INITIAL_EYELINE_STYLE,
	INITIAL_PREVIEW_EYELINE_STYLE,
	INITIAL_EYES_STYLE,
	INITIAL_MOUTH_STYLE,
	INITIAL_PART_NAME,
	INITIAL_FILL_COLOR,
};
